import isomorphicCookie from 'isomorphic-cookie'

const setCookie = (label, value, options) => {
  if (document) {
    const { secure, domain } = options
    let optionsString = ''
    if (secure) optionsString = optionsString + `;secure=${secure}`
    if (domain) optionsString = optionsString + `;domain=${domain}`

    document.cookie = `${label}=${value};path=/` + optionsString
  }
}

const getMainDomain = () => {
  if (process.env.REACT_APP_ALLOWED_DOMAINS) {
    const { mainDomain } = JSON.parse(process.env.REACT_APP_ALLOWED_DOMAINS)
    return mainDomain
  }
  return undefined
}

export const storeAccessToken = accessToken => {
  setCookie('accessToken', accessToken, {
    secure: process.env.NODE_ENV === 'production',
    domain: getMainDomain(),
  })
  localStorage.setItem('accessToken', true)
}

export const deleteAccessToken = async () => {
  await isomorphicCookie.remove('accessToken', {
    secure: process.env.NODE_ENV === 'production',
    domain: getMainDomain(),
    path: '/',
  })
  await isomorphicCookie.remove('web_uuid', {
    secure: process.env.NODE_ENV === 'production',
  })
  await localStorage.removeItem('accessToken')
}

export const getAccessToken = async () => {
  const accessToken = isomorphicCookie.load('accessToken', {
    secure: process.env.NODE_ENV === 'production',
  })

  // if (accessToken) {
  //   const clientSecret = process.env.REACT_APP_JWT_SECRET || 'xxxx'
  //   tokenData = decode(data, clientSecret)
  // }

  return accessToken
}
